module.exports = __webpack_public_path__ + "static/media/bg.169a937d.jpg";